// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","placeholder":"PipelinesBetaBanner__placeholder--Ii"};